import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Dialog from './Dialog';
import baseDialogPropTypes from './baseDialogPropTypes';
/*
 * Component to show a modal popup containing a title, a content and a close handler.
 */
const SimpleDialog = props => {
    const { content, onClose, className } = props;
    const dialogClassName = `${className ? className : ''} simple-dialog`;
    return _jsx(Dialog, Object.assign({}, props, { body: content, onHide: onClose, className: dialogClassName }));
};
SimpleDialog.defaultProps = {
    showCloseButton: true,
};
SimpleDialog.propTypes = Object.assign(Object.assign({}, baseDialogPropTypes), { content: PropTypes.node });
export default SimpleDialog;
